'use client';

import { Container, PrimaryCTA } from 'components/shared';
import { useRef } from 'react';
import { useProductContext } from 'hooks/navigation/useProductContext';
import { CustomImage as Image } from '../shared';
import styles from './HeroSection.module.css';
// import { PrimaryButton } from 'components/shared/PrimaryButton';
// import { useWindowSize } from 'hooks/dom/useWindowSize';
// import { useWindowSize } from 'hooks/dom/useWindowSize';

export const HeroSection = ({
  className,
  onClick,
}: {
  className?: string;
  onClick: () => void;
}) => {
  const { productName } = useProductContext();

    const carouselItems = [
      {
        img: 'web_v2/hero/hero-section/desktop/Healthcare_Workers_latest.jpg',
        text: <>Healthcare Workers</>,
      },
      {
        img: 'web_v2/hero/hero-section/desktop/Athletes_ring-air.jpg',
        text: <>Athletes</>,
      },
      {
        img: 'web_v2/hero/hero-section/desktop/SR_latest.jpg',
        text: <>Scientists & Researchers</>,
      },
      {
        img: 'web_v2/hero/hero-section/desktop/Veterans_latest.jpg',
        text: <>Veterans & Military</>,
      },
      {
        img: 'web_v2/hero/hero-section/desktop/Students_latest.jpg',
        text: <>Education</>,
      },
    ];

    // const { width } = useWindowSize();

    const itemRef = useRef<HTMLDivElement>(null);
    const carousalContainerRef = useRef<HTMLDivElement>(null);
    const ContainerRef = useRef<HTMLDivElement>(null);

    return (
      <section className={`${styles.root}${className ? ` ${className}` : ''}`}>
        <Container>
          <div className={styles.content}>
            <p className={styles.tag}>For those who go beyond</p>
            <h1 className={styles.head}>Heroes of the world</h1>
            <p className={styles.description}>
              Those who serve, care, innovate, and inspire deserve recognition
              for giving their all. In honour of your impact, enjoy exclusive
              pricing on the {productName}.
            </p>
            {/* <CTAButton className="primary " onClick={onClick}> */}
            <PrimaryCTA onClick={onClick} color="black">
              Explore
            </PrimaryCTA>
            {/* </CTAButton> */}
          </div>
        </Container>
        <div className={styles.carousel} ref={ContainerRef}>
          <div className={styles.carouselItems} ref={carousalContainerRef}>
            {carouselItems.map((item, index) => (
              <div className={styles.carouselItem} key={index}>
                {' '}
                <p className={styles.label}>{item.text}</p>
                <div ref={itemRef} className={styles.imgContainer}>
                  <Image src={item.img} fill alt="carousel" />
                </div>
              </div>
            ))}
          </div>{' '}
          <div className={styles.carouselItems}>
            {carouselItems.map((item, index) => (
              <div className={styles.carouselItem} key={index}>
                {' '}
                <p className={styles.label}>{item.text}</p>
                <div ref={itemRef} className={styles.imgContainer}>
                  <Image src={item.img} fill alt="carousel" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };
